import { Component } from '@angular/core';
import { ITableCellItem } from 'app/main/shared/shared/table/table-cell';
import { ITableColumn } from 'app/main/shared/shared/table/table-column';
import { IContractCardsSummaryEntity } from '../match-contract-cards-step.component';
import { Router, UrlSerializer } from '@angular/router';

@Component({
  selector: 'app-cc-name-bulk-upload-column',
  standalone: true,
  imports: [],
  templateUrl: './cc-name-bulk-upload-column.component.html',
  styleUrls: ['./cc-name-bulk-upload-column.component.scss']
})
export class CcNameBulkUploadColumnComponent implements ITableCellItem {
    readonly CC_DETAILS_URL = '/contract-control/view';

    dataItem: IContractCardsSummaryEntity;
    columnOptions: ITableColumn;

   
    constructor(private router: Router, private serializer: UrlSerializer) {}

    navigateToCCDetails() {
      if(this.dataItem?.id && Number.isInteger(this.dataItem?.id)){
        const tree = this.router.createUrlTree([this.CC_DETAILS_URL,  this.dataItem?.id?.toString()]);
        window.open(`#${this.serializer.serialize(tree)}`, '_blank');
      }
    }
}
